import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setRouteHistory } from "../redux/slices/navigationInfo";

export function useRouteHistory() {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (location.hash) return;
    const current = location.pathname + location.search;
    const prev = sessionStorage.getItem("currentRoute");

    if (prev) sessionStorage.setItem("previousRoute", prev);
    sessionStorage.setItem("currentRoute", current);

    dispatch(setRouteHistory({
        current,
        previous: prev
    }));
  }, [location, dispatch]);
}
